import React from 'react';
import { DataTable } from "../../Components/DataTable";

interface DashboardTableSectionProps {
  activeTab: string;
  pendingSubTab: "gdpr" | "documents";
  setPendingSubTab: (subTab: "gdpr" | "documents") => void;
  data: any[];
  columns: any[];
  loading: boolean;
  gdprLength: number;
  documentsLength: number;
}

export const DashboardTableSection: React.FC<DashboardTableSectionProps> = ({
  activeTab,
  pendingSubTab,
  setPendingSubTab,
  data,
  columns,
  loading,
  gdprLength,
  documentsLength,
}) => {
  const getTitle = () => {
    switch (activeTab) {
      case "recent": return "Πρόσφατα Ραντεβού";
      case "today": return "Ραντεβού Σήμερα";
      case "new": return "Νέοι Ασθενείς";
      case "pending": return "Εκκρεμότητες";
      default: return "";
    }
  };

  return (
    <section className="mt-10 bg-white p-6 rounded-xl shadow-sm">
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-xl font-semibold capitalize">{getTitle()}</h2>

        {activeTab === "pending" && (
          <div className="flex space-x-2">
            <button
              onClick={() => setPendingSubTab("gdpr")}
              className={`px-3 py-1.5 text-xs font-bold rounded-lg transition-all ${
                pendingSubTab === "gdpr" ? "bg-primary text-white" : "bg-slate-100 text-slate-600"
              }`}
            >
              GDPR ({gdprLength})
            </button>
            <button
              onClick={() => setPendingSubTab("documents")}
              className={`px-3 py-1.5 text-xs font-bold rounded-lg transition-all ${
                pendingSubTab === "documents" ? "bg-primary text-white" : "bg-slate-100 text-slate-600"
              }`}
            >
              Αρχεία ({documentsLength})
            </button>
          </div>
        )}
      </div>

      {activeTab === "new" ? (
        <div className="p-8 text-center text-slate-400 bg-slate-50 rounded-lg border border-slate-200">
          Δεν έχει καθοριστεί ακόμα.
        </div>
      ) : (
        <DataTable columns={columns} data={data} loading={loading} />
      )}
    </section>
  );
};